import React, { ReactNode, useEffect } from 'react';

import Footer from '../components/Footer';
import ProLayout from '@ant-design/pro-layout';
import { UserOutlined } from '@ant-design/icons';
import RightContent from '../components/RightContent';

// Navigation
import { Link, useLocation } from 'react-router-dom';

// Utils
import getMenuItems from './getMenuItems';
import { useAppSelector } from '../../../store/store';
import { useWindowSize } from '../../../utils/useWindowSize';

// Constants
import { PAGE_TITLE } from '../../../constants/page';
import logo from '../../../assets/images/logo_gba.svg';
import { PRIMARY_COLOR } from '../../../constants/colors';

// Interfaces
import type { IUser } from '../../../interfaces/user';

interface LayoutProps {
  children: ReactNode;
  isWhiteLayout?: boolean;
}

const contentStyle = { margin: 0, padding: 0 } as const;

export const Layout: React.FC<LayoutProps> = (props) => {
  const { width } = useWindowSize();

  const location = useLocation();
  const isMobile = width && width <= 767;

  const user = useAppSelector((state) => state.auth.user) as IUser;

  const routes = getMenuItems(isMobile as boolean, user);

  const layout =
    user &&
    (user.productores_mineros.filter((p) => p.estado === 'activo').length ||
      user.no_productores.length ||
      user.padron_mineros.length)
      ? 'mix'
      : 'top';

  useEffect(() => {
    setTimeout(() => {
      document.title = PAGE_TITLE;
    }, 1);
  }, []);

  return (
    <ProLayout
      layout={layout}
      logo={
        <div style={{ display: 'flex', alignItems: 'center', color: 'white' }}>
          <Link to="/">
            <img style={{ height: 18 }} src={logo}></img>
          </Link>
        </div>
      }
      fixSiderbar
      // @ts-ignore
      title={' '}
      route={routes}
      location={location}
      contentStyle={contentStyle}
      style={{ height: '100vh' }}
      footerRender={() => <Footer />}
      collapsed={!isMobile ? true : undefined}
      className={props.isWhiteLayout ? 'white-layout' : ''}
      collapsedButtonRender={!isMobile ? () => null : undefined}
      avatarProps={{
        size: 'small',
        icon: <UserOutlined />,
        style: { backgroundColor: PRIMARY_COLOR },
        title: isMobile ? undefined : `${user.nombre}`,
        render: (props, dom) => {
          return <RightContent dom={dom} />;
        }
      }}
      menuItemRender={(item, dom) => {
        return <Link to={item.path as string}>{dom}</Link>;
      }}
      token={{
        sider: {
          colorMenuBackground: 'white'
        }
      }}
    >
      <div style={{ minHeight: `calc(100vh - 160px)` }}>{props.children}</div>
    </ProLayout>
  );
};

export default Layout;
